import React from 'react';
import { Typography } from '@shared/ui/typography/typography';
import { STATUS_MAP } from '../../config/ui-constants';
import { Tag } from '@shared/ui/tag/tag';
import { dateStart } from '@shared/lib/utils/date/date';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { useCurrentOrganizationPreviewSharedQuery } from '@entities/organization/libs/hooks/use-current-organization-preview-shared-query/use-current-organization-preview-shared-query';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { CardApprovalEmployeeOrderProps } from './types';
import { Wrapper, Header, ProductInfo, Content, InfoGroup } from './card-approval-employee-order.styles';

export const CardApprovalEmployeeOrder: React.FC<CardApprovalEmployeeOrderProps> = ({ order, onClick }) => {
    const user = useCurrentUserSelector();
    const [, currentOrganization] = useCurrentOrganizationPreviewSharedQuery(user?.company?.id || 0);
    const manager = currentOrganization.data?.manager;

    const managerName = userName({
        firstName: manager?.firstName,
        lastName: manager?.lastName,
        middleName: manager?.middleName,
    });

    return (
        <Wrapper onClick={() => onClick(order.id)}>
            <Header>
                <ProductInfo>
                    <Typography size='subtitle2' color='neutral_90'>
                        {order.product?.name}
                    </Typography>
                </ProductInfo>
            </Header>
            <Content>
                <InfoGroup>
                    <Typography size='body2_long' color='neutral_50'>
                        ID сделки
                    </Typography>
                    <Typography size='body2_long'>{`№${order.id}`}</Typography>
                </InfoGroup>
                <InfoGroup>
                    <Typography size='body2_long' color='neutral_50'>
                        Дата создания сделки
                    </Typography>
                    <Typography size='body2_long'>{dateStart(order.createdAt)}</Typography>
                </InfoGroup>
                <InfoGroup>
                    <Typography size='body2_long' color='neutral_50'>
                        Статус
                    </Typography>
                    <Tag
                        variant={STATUS_MAP[order.status]?.variant}
                        declineMessage={{
                            managerAvatarUrl: manager?.photoUrl || '',
                            managerName: managerName.full,
                            message: order.comment || '',
                        }}>
                        {STATUS_MAP[order.status]?.children}
                    </Tag>
                </InfoGroup>
            </Content>
        </Wrapper>
    );
};
